export default "__VITE_ASSET__BanoI5_g__"